import Graphic from "@arcgis/core/Graphic";
import { setLabels } from "react-chartjs-2/dist/utils";
import { IReportMain } from "../../models/IConfig";
import ConfigService from "../../shared/configService";

export default class DashboardUtils {

    
    public static chooseStateOrCountryGraphic(states:Graphic[], countries:Graphic[], oid:number) {

        const reportMainConfig: IReportMain = ConfigService.getConfig().agol.operationalLayers.reportMain
        let graphic = states.find( (state:Graphic) => state.attributes[reportMainConfig.fields.objectid] == oid);
        if(graphic) {
            graphic.attributes["name"] = graphic.attributes[reportMainConfig.fields.name1];
            graphic.attributes["gid"] = graphic.attributes[reportMainConfig.fields.gid1];           
        } else {
            graphic = countries.find( (country:Graphic) => country.attributes[reportMainConfig.fields.objectid] == oid);
            if(graphic) {
                graphic.attributes["name"] = graphic.attributes[reportMainConfig.fields.name0];
                graphic.attributes["gid"] = graphic.attributes[reportMainConfig.fields.gid0];
            }
        }

        return graphic;
    }

    public static groupBy(array:any[], key:string) {
        // Return the end result
        if(!array || array.length==0 ) {
            return {};
        } else {
            
            return array.reduce((result, currentValue) => {
            // If an array already present for key, push it to the array. Else create an array and push the object
            (result[currentValue[key]] = result[currentValue[key]] || []).push(
                currentValue
            );
            // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
            return result;
            }, {}); // empty object is the initial value for result object
        }
    }
    
    /**
     * Create chart labels
     * @param inObject
     * @returns
     */
    public static createChartLabels(inObject: any): any[] {
        let labels: any[] = Object.keys(inObject) && Object.keys(inObject).length == 1 && Object.keys(inObject)[0] === "null" ? ["-"] : Object.keys(inObject);
        
        labels = labels.map(item => {
            if (item === undefined || item === null || item === 'null') {
                return '-';
            }
            else if (item.split(' ').length > 1) {
                const arr: string[] = item.split(' ');
                const newArr: string[] = [];

                for (let i=0; i < arr.length; i += 2) {
                    const word1: string = arr[i];
                    const word2: string = i + 1 < arr.length ? ` ${arr[i + 1]}` : '';

                    newArr.push(`${word1}${word2}`)
                }

                return newArr;
            } else {
                return item;
            }
        });
        
        return labels;
    }
    
}